import { ChangeDetectionStrategy, Component, inject, OnDestroy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Package } from '../../../../../packages/package'
import { TerminalOrderPackageDetailComponent } from '../terminal-order-package-detail/terminal-order-package-detail.component'
import { BehaviorSubject } from 'rxjs'
import { AsyncPipe } from '@angular/common'
import { PackageService } from '../../../../../packages/package.service'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'

export interface TerminalOrderPackageDialogueOptions {
  readonly pkgId: string
}

@Component({
  selector: 'app-terminal-order-package-detail-dialogue',
  imports: [TerminalOrderPackageDetailComponent, AsyncPipe],
  template: ` <div class="layout-col full bg-background">
    @if (pkg$ | async; as pkg) {
      <app-terminal-order-package-detail
        class="flex"
        [pkg]="pkg"
        (close)="close()"
        (refresh)="refresh(pkg)"
      ></app-terminal-order-package-detail>
    }
  </div>`,
  styles: '',
})
export class TerminalOrderPackageDetailDialogueComponent {
  pkg$ = new BehaviorSubject<Package | null>(null)
  private packageService = inject(PackageService)
  private dialogRef =
    inject<MatDialogRef<TerminalOrderPackageDetailDialogueComponent>>(MatDialogRef)

  constructor() {
    const { pkgId } = inject<TerminalOrderPackageDialogueOptions>(MAT_DIALOG_DATA)
    this.packageService
      .findById(pkgId)
      .pipe(takeUntilDestroyed())
      .subscribe((pkg) => this.pkg$.next(pkg))
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  close(): void {
    this.dialogRef.close()
  }

  refresh(pkg: Package): void {
    this.pkg$.next(pkg)
  }
}
